export const domainDetails = {
  chargemiles: {
    palette: {
      primary: {
        lighter: "#C8FACD",
        light: "#5BE584",
        main: "#00AB55",
        dark: "#007B55",
        darker: "#005249",
        contrastText: "#fff",
      },
    },
    email:"support@chargemiles.ca",
    name: "ChargeMiles",
    logoUrl: "logo/chargemiles.jpeg",
    faviconUrl: "chargemilesFavicon.ico",
    title: "ChargeMiles-CMS",
    mapUrl: "https://map.chargemiles.ca",
    domain:"chargemiles",
    filterColor:
      "invert(20%) sepia(100%) saturate(5000%) hue-rotate(100deg) brightness(95%) contrast(105%);",
  },
  moveonev: {
    domain:"moveonev",
    palette: {
      primary: {
        lighter: "#C8FACD",
        light: "#5BE584",
        main: "#dc3545",
        dark: "#A60020",
        darker: "#005249",
        contrastText: "#fff",
      },
    },
    email:"info@moveonev.com",
    name: "MoveonEV",
    logoUrl: "logo/moveon.png",
    title: "MoveonEV-CMS",
    mapUrl: "https://map.moveonev.com",
    faviconUrl: "moveonevfavicon.ico",
    filterColor:
      "invert(25%) sepia(89%) saturate(3548%) hue-rotate(341deg) brightness(94%) contrast(82%);",
  },
  amikcharge: {
    domain:"amikcharge",
    palette: {
      primary: {
        lighter: "#E6F3FF",
        light: "#B3D9FF",
        main: "#4A90E2",
        dark: "#2E5BBA",
        darker: "#1E3A8A",
        contrastText: "#fff",
      },
    },
    email:"info@amiktech.in",
    name: "Amik",
    logoUrl: "logo/amikCharge.svg",
    title: "AmikCharge-CMS",
    mapUrl: "https://map.amiktechnologies.com",
    faviconUrl: "static/amikChargeFavicon.ico",
    filterColor:
      " brightness(0) saturate(100%) invert(33%) sepia(31%) saturate(4652%) hue-rotate(197deg) brightness(101%) contrast(110%)",
  },
  amiktechnologies: {
    domain:"amiktechnologies",
    palette: {
      primary: {
        lighter: "#E6F3FF",
        light: "#B3D9FF",
        main: "#4A90E2",
        dark: "#2E5BBA",
        darker: "#1E3A8A",
        contrastText: "#fff",
      },
    },
    email:"info@amiktech.in",
    name: "Amik",
    logoUrl: "logo/amikLogo.svg",
    title: "AMIKTechnologies-CMS",
    mapUrl: "https://map.amiktechnologies.com",
    faviconUrl: "static/amikChargeFavicon.ico",
    filterColor:
      " brightness(0) saturate(100%) invert(33%) sepia(31%) saturate(4652%) hue-rotate(197deg) brightness(101%) contrast(110%)",
  },
  techvoltnetwork: {
    domain:"techvoltnetwork",
    palette: {
      primary: {
        lighter: "#52D28E",
        light: "#2FB873",
        main: "#149631",
        dark: "#0F6E24",
        darker: "#0A4B18",
        contrastText: "#fff"
      },      
    },
    email:"techvoltnetwork@gmail.com",
    name: "Techvolt",
    logoUrl: "logo/techvoltNetwork.jpg",
    title: "Techvolt-CMS",
    mapUrl: "https://map.techvoltnetwork.com",
    faviconUrl: "static/techvoltNetworkFavicon.ico",
    filterColor:
      "invert(20%) sepia(100%) saturate(5000%) hue-rotate(100deg) brightness(95%) contrast(105%);",
  },
  acsenergy: {
    domain:"acsenergy",
    palette: {
      primary: {
        lighter: "#C8FACD",
        light: "#5BE584",
        main: "#007fff",
        dark: "#003366",
        darker: "#005249",
        contrastText: "#fff",
      },
    },
    email:"support@acsenergy.in",
    name: "ACS Energy",
    logoUrl: "https://avvmedia.blob.core.windows.net/avv-media/networkFilters/ACSEnergyLogo_BlackFont.png",
    title: "ACSEnergy-CMS",
    mapUrl: "https://map.acsenergy.in",
    faviconUrl: "static/acsFavicon.ico",
    filterColor:
      " brightness(0) saturate(100%) invert(33%) sepia(31%) saturate(4652%) hue-rotate(197deg) brightness(101%) contrast(110%)",
  },
  avvtech: {
    domain:"avvtech",
    palette: {
      primary: {
        lighter: "#B3E5FC",
        light: "#4FC3F7",
        main: "#03A9F4",
        dark: "#0288D1",
        darker: "#01579B",
        contrastText: "#fff",
      },
    },
    email:"info@avvtech.ca",
    name: "AvvTech",
    logoUrl: "https://static.joonsite.com/storage/4854/media/2411300853545403.png",
    title: "AvvTech-CMS",
    mapUrl: "https://map.avvtech.ca",
    faviconUrl: "static/amikChargeFavicon.ico",
    filterColor:
      "brightness(0) saturate(100%) invert(46%) sepia(85%) saturate(1471%) hue-rotate(192deg) brightness(101%) contrast(102%)",
  },
  zerofootprint: {
    domain:"zerofootprint",
    palette: {
      primary: {
        lighter: "#52D28E",
        light: "#2FB873",
        main: "#149631",
        dark: "#0F6E24",
        darker: "#0A4B18",
        contrastText: "#fff"
      },      
    },
    email:"support@zerofootprint.in",
    name: "ZeroFootprint",
    logoUrl: "logo/zerofootprint.png",
    title: "ZeroFootprint-CMS",
    mapUrl: "https://map.zerofootprint.in",
    faviconUrl: "static/zerofootprintFavicon.ico",
    filterColor:
      "invert(20%) sepia(100%) saturate(5000%) hue-rotate(100deg) brightness(95%) contrast(105%);",
  },
};
